import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Mask" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("circle", {
			id: "path-1",
			cx: 12,
			cy: 12,
			r: 12
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Command-/-Radio-/-enabled",
				transform: "translate(-8.000000, -12.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-2",
					transform: "translate(8.000000, 12.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Colors/Accent/Accent-+-Mask-Mask",
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "mask-2",
							fill: "white",
							children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
						}), /* @__PURE__ */ _jsx("circle", {
							stroke: "#0056C1",
							fill: "#0056C1",
							strokeWidth: 2,
							cx: 12,
							cy: 12,
							r: 11
						})]
					})
				})
			})
		})
	]
});
export default SvgSpot;
